// Models offered wherever an intent test can pin the LLM: the single-sentence
// tester and the LLM vs legacy comparison runs. Kept in one place so a new model
// shows up in both without anyone having to remember the second list.
export const MODEL_OPTIONS = [
  { value: "gemini/gemini-2.5-flash", label: "Gemini 2.5 Flash" },
  { value: "openai/gpt-5.1", label: "GPT 5.1" },
  { value: "gemini/gemini-2.5-flash-lite", label: "Gemini 2.5 Flash Lite" },
  { value: "gemini/gemini-3.5-flash-lite", label: "Gemini 3.5 Flash Lite" },
  { value: "openai/gpt-5.4-mini", label: "GPT 5.4 Mini" },
  // Downstream agent default when no model is passed (see the bulk "Test Models" runs).
  { value: "openai/gpt-5-nano", label: "GPT 5 Nano" },
  // Fast/cheap models served through Amazon Bedrock (litellm bedrock/ prefix).
  { value: "bedrock/deepseek.v3.2", label: "DeepSeek V3.2 (Bedrock)" },
  { value: "bedrock/qwen.qwen3-32b-v1:0", label: "Qwen3 32B (Bedrock)" },
  { value: "bedrock/nvidia.nemotron-nano-9b-v2", label: "Nemotron Nano 9B (Bedrock)" },
  { value: "bedrock/zai.glm-4.7-flash", label: "GLM 4.7 Flash (Bedrock)" },
];

export const MODEL_LABEL_BY_VALUE = MODEL_OPTIONS.reduce((acc, m) => {
  acc[m.value] = m.label;
  return acc;
}, {});

export default MODEL_OPTIONS;
